var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencilIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon pencil-icon",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26 0a1.738 1.738 0 011.312 2.883l-.082.087-5.987 5.988a.46.46 0 01-.113.082l-.065.028-2.727.909a.467.467 0 01-.287 0 .454.454 0 01-.303-.515l.015-.06.91-2.727a.423.423 0 01.064-.125l.045-.053L7.029.51A1.729 1.729 0 018.259 0zM2.029 7.195l-.02.02-.386 1.162 1.159-.387.021-.021-.774-.774zm6.23-6.001a.538.538 0 00-.32.103l-.066.057-5 4.997.774.774 4.971-4.97.055-.057a.546.546 0 00-.327-.898l-.086-.006z"
  })));
}

export default SvgPencilIconSv;